import ReactDOM from 'react-dom';
function renderWithDriver(element, onHide) {
    const root = document.createElement('div');
    let hid = false;
    const hide = () => {
        if (hid) {
            return;
        }
        try {
            hid = true;
            ReactDOM.unmountComponentAtNode(root);
            document.body.removeChild(root);
            if (onHide) {
                onHide();
            }
        }
        catch (e) {
            throw new Error('remove element error');
        }
    };
    document.body.appendChild(root);
    ReactDOM.render(element, root);
    return hide;
}
/**
 * 将元素快捷渲染到Root中
 * @param element
 * @param onHide
 * @return () => void
 */
export function renderToRoot(element, onHide) {
    return renderWithDriver(element, onHide);
}
